import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';

export const ServiceCard = ({ service, large = false }) => (
  <Link
    to={`/services/${service.slug}/`}
    data-testid={`service-card-${service.slug}`}
    className="group block border border-line bg-paper transition-colors hover:border-bronze/60"
  >
    <div className={`img-frame ${large ? 'aspect-[16/10]' : 'aspect-[16/11]'}`}>
      <img src={service.image.src} alt={service.image.alt} loading="lazy" className="group-hover:scale-105" />
    </div>
    <div className="p-6 md:p-7">
      <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-bronze">{service.category}</p>
      <h3 className="mt-2 font-serif text-2xl font-medium tracking-tight text-ink transition-colors group-hover:text-bronze">{service.title}</h3>
      <p className="mt-2.5 text-sm leading-relaxed text-muted2">{service.excerpt}</p>
      <span className="mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors group-hover:text-bronze">
        Explore <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
      </span>
    </div>
  </Link>
);

export const ProjectCard = ({ project }) => (
  <Link to={`/projects/${project.slug}/`} data-testid={`project-card-${project.slug}`} className="group block">
    <div className="img-frame relative aspect-[4/3]">
      <img src={project.image.src} alt={project.image.alt} loading="lazy" className="group-hover:scale-105" />
      <span className="absolute left-4 top-4 flex h-9 w-9 items-center justify-center bg-paper/90 text-ink opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </div>
    <div className="mt-4">
      <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-bronze">{project.category}</p>
      <h3 className="mt-1.5 font-serif text-xl font-medium tracking-tight text-ink transition-colors group-hover:text-bronze">{project.title}</h3>
      <p className="mt-1.5 line-clamp-2 text-sm text-muted2">{project.summary}</p>
    </div>
  </Link>
);

export const BlogCard = ({ post }) => (
  <Link to={`/blog/${post.slug}/`} data-testid={`blog-card-${post.slug}`} className="group block border border-line bg-paper transition-colors hover:border-bronze/60">
    <div className="img-frame aspect-[16/10]">
      <img src={post.image.src} alt={post.image.alt} loading="lazy" className="group-hover:scale-105" />
    </div>
    <div className="p-6">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-bronze">
        <span>{post.category}</span>
        <span className="text-muted2/60">{post.readTime}</span>
      </div>
      <h3 className="mt-2.5 font-serif text-xl font-medium leading-snug tracking-tight text-ink transition-colors group-hover:text-bronze">{post.title}</h3>
      <p className="mt-2 line-clamp-2 text-sm text-muted2">{post.excerpt}</p>
      <p className="mt-4 text-xs text-muted2/70">{post.date}</p>
    </div>
  </Link>
);

export const LocationCard = ({ location }) => (
  <Link to={`/service-areas/${location.slug}/`} data-testid={`location-card-${location.slug}`} className="group relative block overflow-hidden border border-line">
    <div className="img-frame aspect-[16/9]">
      <img src={location.image.src} alt={location.image.alt} loading="lazy" className="group-hover:scale-105" />
    </div>
    <div className="flex items-center justify-between p-5">
      <div>
        <h3 className="font-serif text-xl font-medium text-ink transition-colors group-hover:text-bronze">{location.city}, NE</h3>
        <p className="text-xs text-muted2">{location.region}</p>
      </div>
      <ArrowUpRight className="h-5 w-5 text-bronze transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </div>
  </Link>
);
